import { default as _91_46_46_46slug_93EhWyQvnGPmMeta } from "/opt/build/repo/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46unprefixed_93k8jiAFiAveMeta } from "/opt/build/repo/pages/[...unprefixed].vue?macro=true";
import { default as _91_46_46_46slug_93uCHqBEJ1GwMeta } from "/opt/build/repo/pages/ad/[...slug].vue?macro=true";
import { default as _91adId_93TzSGfE1gjoMeta } from "/opt/build/repo/pages/fb-campaign/[adId].vue?macro=true";
import { default as _91_46_46_46slug_93MNmlUVAmZ3Meta } from "/opt/build/repo/pages/in-app/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_937GSwhM3iV8Meta } from "/opt/build/repo/pages/invite/[...slug].vue?macro=true";
import { default as _91code_93DvYcPjhi9OMeta } from "/opt/build/repo/pages/redeem/[code].vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en-gb",
    path: "/en-gb/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___en-se",
    path: "/en-se/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___en-de",
    path: "/en-de/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___en-at",
    path: "/en-at/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___en-pt",
    path: "/en-pt/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___sv-se",
    path: "/sv-se/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___de-de",
    path: "/de-de/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___de-at",
    path: "/de-at/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "slug___pt-pt",
    path: "/pt-pt/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "unprefixed",
    path: "/:unprefixed(.*)*",
    component: () => import("/opt/build/repo/pages/[...unprefixed].vue")
  },
  {
    name: "ad-slug___en-gb",
    path: "/en-gb/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___en-se",
    path: "/en-se/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___en-de",
    path: "/en-de/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___en-at",
    path: "/en-at/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___en-pt",
    path: "/en-pt/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___sv-se",
    path: "/sv-se/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___de-de",
    path: "/de-de/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___de-at",
    path: "/de-at/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "ad-slug___pt-pt",
    path: "/pt-pt/ad/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/ad/[...slug].vue")
  },
  {
    name: "fb-campaign-adId___en-gb",
    path: "/en-gb/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___en-se",
    path: "/en-se/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___en-de",
    path: "/en-de/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___en-at",
    path: "/en-at/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___en-pt",
    path: "/en-pt/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___sv-se",
    path: "/sv-se/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___de-de",
    path: "/de-de/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___de-at",
    path: "/de-at/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "fb-campaign-adId___pt-pt",
    path: "/pt-pt/fb-campaign/:adId()",
    meta: _91adId_93TzSGfE1gjoMeta || {},
    component: () => import("/opt/build/repo/pages/fb-campaign/[adId].vue")
  },
  {
    name: "in-app-slug___en-gb",
    path: "/en-gb/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___en-se",
    path: "/en-se/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___en-de",
    path: "/en-de/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___en-at",
    path: "/en-at/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___en-pt",
    path: "/en-pt/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___sv-se",
    path: "/sv-se/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___de-de",
    path: "/de-de/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___de-at",
    path: "/de-at/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "in-app-slug___pt-pt",
    path: "/pt-pt/in-app/:slug(.*)*",
    meta: _91_46_46_46slug_93MNmlUVAmZ3Meta || {},
    component: () => import("/opt/build/repo/pages/in-app/[...slug].vue")
  },
  {
    name: "invite-slug___en-gb",
    path: "/en-gb/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___en-se",
    path: "/en-se/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___en-de",
    path: "/en-de/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___en-at",
    path: "/en-at/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___en-pt",
    path: "/en-pt/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___sv-se",
    path: "/sv-se/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___de-de",
    path: "/de-de/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___de-at",
    path: "/de-at/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "invite-slug___pt-pt",
    path: "/pt-pt/invite/:slug(.*)*",
    meta: _91_46_46_46slug_937GSwhM3iV8Meta || {},
    component: () => import("/opt/build/repo/pages/invite/[...slug].vue")
  },
  {
    name: "redeem-code___en-gb",
    path: "/en-gb/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___en-se",
    path: "/en-se/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___en-de",
    path: "/en-de/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___en-at",
    path: "/en-at/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___en-pt",
    path: "/en-pt/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___sv-se",
    path: "/sv-se/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___de-de",
    path: "/de-de/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___de-at",
    path: "/de-at/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: "redeem-code___pt-pt",
    path: "/pt-pt/redeem/:code()",
    component: () => import("/opt/build/repo/pages/redeem/[code].vue")
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en-GB-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en-SE-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en-DE-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en-AT-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en-PT-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sv-SE-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/de-DE-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/de-AT-sitemap.xml",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/pt-PT-sitemap.xml",
    component: component_45stubRU5sOBTecH
  }
]